<template lang="html">
  <v-app class="page">
    <splash v-if="validatingToken"></splash>
    <v-card v-else>
      <v-container class="center">
        <v-layout row>
          <!-- come back to fix the avatar -->
          <v-flex class="avatar mt-4">
            <v-avatar
              :tile="true"
              :size="100"
            >
              <img src="../assets/logo.svg" alt="Logo">
            </v-avatar>
          </v-flex>
        </v-layout>

        <!-- fb login -->
        <br/>
        <v-layout row>
          <v-flex>
            <facebook-login
              :facebookAppId="facebookAppId"
              :callback="facebookLogin"
            >
              Continue with Facebook
            </facebook-login>
          </v-flex>
        </v-layout>

        <!-- google login -->
        <v-layout row>
          <v-flex>
            <google-login :callback="googleLogin"/>
          </v-flex>
        </v-layout>

        <div class="or-seperator">
          or
        </div>


        <v-form class="login-form mt-4">
          <v-layout row class="login-input-container input-top unset-center m-auto">
            <v-flex sm3>
              <label class="email-label" for="Email">Email</label>
            </v-flex>
            <v-flex sm9>
              <input
                type="email"
                style="width: 100%; height: 100%;"
                placeholder="Email"
                v-model="email">
               </input>
            </v-flex>
          </v-layout>

          <v-layout row v-if="siteKey">
            <vue-recaptcha class="recaptcha" @verify="recaptchaVerify" :sitekey="siteKey"></vue-recaptcha>
          </v-layout>

          <v-layout row>
            <v-flex>
              <v-btn class="login-button white--text" v-on:click="userLogin" :loading="dataLoading" :disabled="disableSubmit">
                <strong>
                  Login with E-Mail
                </strong>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card>
  </v-app>
</template>

<script>
import get from 'lodash/get';
import VueRecaptcha from 'vue-recaptcha';
import {
  facebookSSOInformation,
  fetchGoogleSiteKey,
} from '@/api';

import FacebookLogin from './FacebookLogin';
import GoogleLogin from './GoogleLogin';
import Splash from './Splash';

export default {
  components: {
    GoogleLogin,
    FacebookLogin,
    splash: Splash,
    VueRecaptcha,
  },
  data() {
    return {
      email: '',
      facebookAppId: null,
      siteKey: null,

      recaptchaResponse: null,
    };
  },
  methods: {
    recaptchaVerify(response) {
      this.recaptchaResponse = response;
    },
    userLogin() {
      this.$store.dispatch('auth/userLogin', {
        username: this.email,
        'g-recaptcha-response': this.recaptchaResponse,
      });
    },
    facebookLogin(token) {
      this.$store.dispatch('auth/facebookLogin', {
        token,
        redirectUrl: '/effort',
        router: this.$router,
      });
    },
    googleLogin(token) {
      this.$store.dispatch('auth/googleLogin', {
        token,
        redirectUrl: '/effort',
        router: this.$router,
      });
    },
    ssoInformation() {
      facebookSSOInformation()
        .then((response) => {
          this.facebookAppId = get(response, 'data[1].data.details.facebook_app_id');
        });
    },
    recaptchaInformation: async function recaptchaInformation() {
      const { data } = await fetchGoogleSiteKey();
      this.siteKey = get(data, '[1].data.details.recaptcha_key');
    },
  },
  computed: {
    disableSubmit() {
      return !this.recaptchaVerified || !this.email;
    },
    recaptchaVerified() {
      return !!this.recaptchaResponse;
    },
    dataLoading() {
      return this.$store.getters['auth/authenticating'];
    },
    validatingToken() {
      return this.$store.getters['auth/validatingToken'];
    },
  },
  mounted() {
    this.ssoInformation();
    this.recaptchaInformation();
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";
#app {
    // card related
    .card {
      height: 100vh !important;
      margin: 0;
      padding: 0;
    }

    // avatar realted
    @media only screen and (max-width: 800px) {
      .avater {
        margin-top: 11.0%;
        margin-bottom: 5.8%;
        margin-left: 36%;
        margin-right: 36%;
      }
    }

    @media only screen and (min-width: 800px) {
      .avater {
        margin-top: 50px;
        margin-bottom: 50px;
        margin-left: 36%;
        margin-right: 36%;
      }
    }

    .avater img {
      max-width: 100px;
      max-height: 100px;
    }

    // login form related
    .login-form {
      width: 100%;
    }

    .login-input-container {
      width: 100%;
      min-width: 270px;
      max-width: 306px;
      height: 50px;
      border-color: $border-color;
    }

    .login-input-container label {
      color: $blue;
      font-family: MuseoSans-500;
      vertical-align: -webkit-baseline-middle;
    }

    .login-input-container input:focus, .login-input-container textarea:focus {
      outline: none;
    }

    .input-top {
      border-radius: 8px 8px 8px 8px;
      box-shadow: 1px 0px 6px 0 $border-color;
    }

    .input-bottom {
      border-radius: 0px 0px 8px 8px;
      box-shadow: 1px 4px 6px 0 $border-color;
    }

    @media only screen and (max-width: 800px) {
      .login-input-container label {
        padding-left: 10px;
      }
    }

    @media only screen and (min-width: 800px) {
      .login-input-container label {
        padding-left: 20px;
        padding-right: 30px;
      }
    }


    // login button realted
    .login-button {
      color: white;
      height: 50px;
      min-width: 306px;
      border-radius: 100px;
      background: $primary-red;
      background: $primary;
      font-family: MuseoSans-500;
      margin-top: 20px;
    }

    .recaptcha {
      margin-left: auto;
      margin-right: auto;
      margin-top: 15px;
    }

    .email-label {
      display: inline-block;
      margin-top: 15px;
    }

    .or-seperator {
      margin-top: 25px;
      margin-bottom: 25px;
      font-weight: bold;
      font-size: 14px;
      color: $light;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue